<script lang="ts">
    import { selectedId } from '../stores';
	import { fade } from 'svelte/transition';

    export let models = [];

</script>

<div class="flex flex-col text-white" id="picker">
    <h1 class="text-white text-4xl font-bold px-2 mb-6">Kérlek válaszd ki melyik típusra szeretnél ajánlatot kérni</h1>

    <div class="flex flex-wrap" transition:fade="{{ duration: 1000 }}">
        {#each models as model}
            <div class="flex justify-center w-1/2 lg:w-1/4 xl:w-1/5 relative">
                <input type="radio" name="model" id="model_{model.id}"/>
                <label class="cursor-pointer p-2 img-label" for="model_{model.id}">
                    <img src="/model_images/{model.id}.jpg" class="rounded-2xl" on:click={selectedId.set(model.id)}/>
                </label>
                <span class="absolute bottom-0 sm:px-2 py-1 bg-blue-600 rounded -mb-2 font-semibold bg-opacity-80">{model.name}</span>
            </div>
        {/each}
    </div>
</div>

<style>

    input[type="radio"][id^="model_"] {
        display: none;
    }

    .img-label {
        display: block;
        position: relative;
        /*margin: 10px;*/
        cursor: pointer;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .img-label::before {
        content: " ";
        display: block;
        border-radius: 50%;
        position: absolute;
        top: -5px;
        left: -5px;
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        transition-duration: 0.4s;
        transform: scale(0);
    }

    .img-label img {
        transition-duration: 0.2s;
        transform-origin: 50% 50%;
    }

    :checked+.img-label::before {
        content: url(/img/done.svg);
        background-color: transparent;
        color: red;
        z-index: 40;
        transform: scale(1);
    }

    :checked+.img-label img {
        transform: scale(1.1);
        box-shadow: 0 0 5px #333;
        z-index: -1;
    }
</style>